/* unplugin-vue-components disabled */import { render } from "./StaticRoleCard.vue?vue&type=template&id=c92a022a&scoped=true"
import script from "./StaticRoleCard.vue?vue&type=script&lang=js"
export * from "./StaticRoleCard.vue?vue&type=script&lang=js"

import "./StaticRoleCard.vue?vue&type=style&index=0&id=c92a022a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户哈工程-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92a022a"]])

export default __exports__